module.exports = __webpack_public_path__ + "img/43.55d02b00.jpg";